import React from 'react';
import { HEADERS_MULTISTEP } from './utils/index.js';

function MultistepFormsNav({
  activeIndex,
  disabledIndex,
  onBack,
  onSubmit,
  type,
}) {
  return (
    <div className="flex flex-justify steps-nav m-b-48">
      <button
        type="button"
        className="btn-back btn btn-default m-b-8 m-r-8"
        onClick={onBack}
        disabled={!onBack}
      ></button>
      <div className="flex flex-wrap">
        {HEADERS_MULTISTEP[type].map((step, index) => (
          <h3
            key={index}
            className={`text-muted flex nav-item m-b-8  ${index === activeIndex && 'active'}`}
          >
            <span
              className={`order m-r-8  ${index !== activeIndex ? 'disabled' : ''}`}
            >
              {index + 1}
            </span>
            {step.name}
            {index + 1 !== HEADERS_MULTISTEP[type].length ? (
              <span className="divider"></span>
            ) : null}
          </h3>
        ))}
      </div>
      <button
        type="button"
        disabled={!onSubmit}
        className="btn-next btn btn-default m-b-8 m-l-8"
        onClick={onSubmit}
      ></button>
    </div>
  );
}

export default MultistepFormsNav;
